import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import React from "react";
import {Link} from "react-router-dom";
// const useStyles = makeStyles(
//   () => ({
//     ptButton: {
//       marginRight: "40px",
//     },
//     siteFooterBox: {
//       alignItems: "center",
//       background: "#f7f7f7",
//       bottom: "0",
//       display: "flex",
//       justifyContent: "flex-end",
//       position: "relative",
//     },
//   }),
//   {name: "SiteFooter"}
// );

export const Footer: React.FC = () => {
  return (
    <Box
      component="div"
      sx={{display: "flex", justifyContent: "space-between"}}
    >
      <Stack direction="row" spacing={2}>
        <Box component="div" sx={{display: "inline-flex"}}>
          <Link to="/t_c">Terms of Service</Link>
        </Box>
        <Box component="div" sx={{display: "inline-flex"}}>
          <Link to="/privacy">Privacy Policy</Link>
        </Box>
        <Box component="div" sx={{display: "inline-flex"}}>
          <div>2023 © Lever Data Solutions Limited</div>
        </Box>
      </Stack>
      <Stack direction="row" spacing={1}>
        <Box
          component="a"
          sx={{display: "inline-flex"}}
          onClick={() =>
            window.open("https://www.facebook.com/Checkafy", "_blank")
          }
        >
          <FacebookIcon sx={{color: "#3b5998"}} fontSize="large" />
        </Box>
        <Box
          component="a"
          sx={{display: "inline-flex"}}
          onClick={() =>
            window.open("https://www.instagram.com/checkafy/", "_blank")
          }
        >
          <InstagramIcon sx={{color: "#ea0c5f"}} fontSize="large" />
        </Box>
      </Stack>
    </Box>
  );
};
